<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Assign.scss";
</style>
<template>
  <div>
    <div class="vx-row w-full">
        <vs-button :to="`/circuitos/${uuid}`" class="w-full my-2 sm:w-auto" color="primary" type="filled">{{$t('Labels.Back')}}</vs-button>
    </div>
    <div class="text-lg font-bold py-4">{{name}}</div>
    <div class="w-full mt-4 text-right">
      <vs-button @click="requestPassword()" class="submit-button" >
        {{$t('Labels.Save')}}
      </vs-button>
    </div>
    <div class="flex w-full">
      <div class="flex-1">
        <div class="w-full text-center font-bold mb-2">{{$t('Labels.NotAssigned')}}</div>
        <div class="text-center py-3" v-if="unassigned.length === 0">{{$t('Messages.NotLuminaries')}}</div>
        <ul>
          <li :key="index" v-for="(item, index) in unassigned"  class="text-center p-1 cursor-pointer rounded-sm">
            <vx-card class="h-auto" :class="{ 'item-selected': item.selected,'border-cyan': item.selected,  'border-4': item.selected}" @click="item.selected = !item.selected">
              {{ item.name }}
            </vx-card>
          </li>
        </ul>
      </div>
      <div class="flex-initial m-auto px-4">
        <vs-button class="mb-3" radius color="primary" type="filled" icon-pack="feather" icon="icon-arrow-right block" @click="assign()" ></vs-button>
        <vs-button radius color="primary" type="filled" icon-pack="feather" icon="icon-arrow-left block" @click="unassign()" ></vs-button>
      </div>
      <div class="flex-1">
        <div class="w-full text-center font-bold mb-2">{{$t('Labels.Assigned')}}</div>
        <div class="text-center py-3" v-if="assigned.length === 0">{{$t('Messages.NotAssignedLuminaries')}}</div>
          <ul>
          <li :key="index" v-for="(item, index) in assigned" class="text-center p-1 cursor-pointer rounded-sm">
            <vx-card class="h-auto" :class="{ 'item-selected': item.selected, 'border-cyan': item.selected,  'border-4': item.selected}" @click="item.selected = !item.selected">
              {{ item.name }}
            </vx-card>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import {request} from '@/request.js'
import {empty} from '@/helpers.js'
import {globalPassActions} from '@/globalPass'

export default {
  data () {
    return {
      uuid: this.$route.params.uuid,
      unassigned:[],
      assigned:[],
      filters:{
        limit: 10000000000,
        offset: 0,
        byColumn: 'name',
        byOrder: 'ASC',
        luminary_circuit_uuid: this.$route.params.uuid
      },
      currentx: 1,
      totalPages: 0,
      name: ''
    }
  },
  methods: {
    async getCircuit () {
      const params = {
        url: `luminaires_circuits/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.name = response.data.data.name
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    async getAssigned () {
      const params = {
        url: 'luminaires_devices',
        method: 'GET',
        params: this.filters
      }
      await request(params).then(response => {
        response.data.data.rows.forEach(function (item) {
          item['selected'] = false
        })
        this.assigned = response.data.data.rows
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    async getUnassigned () {
      const filter = this.filters
      filter.luminary_circuit_uuid = null
      filter.asign = 0
      const params = {
        url: 'luminaires_devices',
        method: 'GET',
        params: filter
      }
      await request(params).then(response => {
        response.data.data.rows.forEach(function (item) {
          item['selected'] = false
        })
        this.unassigned = response.data.data.rows
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    setPages (total) {
      this.totalPages = Math.ceil(total / this.filters.limit)
    },   
    assign () {
      const toMove = this.unassigned.filter(element => element.selected === true)
      this.unassigned = this.unassigned.filter(element => element.selected === false)
      toMove.map(item => {
        item.selected = false
        this.assigned.push(item)
      })
    },
    unassign () {
      const toMove = this.assigned.filter(element => element.selected === true)
      this.assigned = this.assigned.filter(element => element.selected === false)
      toMove.map(item => {
        item.selected = false
        this.unassigned.push(item)
      })
    },
    async save () {
      const uuids = this.assigned.map(item => {
        return item.uuid
      })
      const data = {
        url: `luminaires_circuits/${this.uuid}/assign_luminaires`,
        method: 'PUT',
        params: {
          uuids: uuids.join(',')
        }
      }
      await request(data).then(() => {

      })
    },
    requestPassword () {
      globalPassActions.show()
    }
  },
  created () {
    this.getCircuit()
    this.getAssigned()
    this.getUnassigned()
  },
  computed: {
    isVisiblePassword () {
      return globalPassActions.getStatus()
    }
  },
  watch: {
    currentx (val) {
      this.filters.offset = (val - 1) * this.filters.limit
      this.getResponse()
    },
    isVisiblePassword (visible) {
      if (!empty(globalPassActions.get()) && visible === false) this.save()
    }
  }
}
</script>